// import React from "react";
// import Slider from "react-slick";
// import {
//   Box,
//   Typography,
//   Card,
//   CardContent,
//   Avatar,
//   Container
// } from "@mui/material";

// import girlIcon from "../../assets/images/girlicon.png";
// import boyIcon from "../../assets/images/girlicon.png";

// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// const testimonials = [
//   {
//     name: "Riya Sharma",
//     designation: "Java Intern",
//     description:
//       "This internship helped me improve my coding skills and gave me real industry experience.",
//     image: girlIcon
//   },
//   {
//     name: "Rahul Verma",
//     designation: "React Intern",
//     description:
//       "Amazing mentors and real projects. I learned React and built production level apps.",
//     image: boyIcon
//   },
//   {
//     name: "Priya Patel",
//     designation: "Python Intern",
//     description:
//       "Great environment for learning. I gained confidence working on real development tasks.",
//     image: girlIcon
//   },
//   {
//     name: "Aman Singh",
//     designation: "Full Stack Intern",
//     description:
//       "The internship experience was incredible. I improved both frontend and backend skills.",
//     image: boyIcon
//   }
// ];

// const TestimonialSection = () => {

//   const settings = {
//     dots: false,
//     infinite: true,
//     speed: 3000,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 0,
//     cssEase: "linear",
//     pauseOnHover: true,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: { slidesToShow: 2 }
//       },
//       {
//         breakpoint: 600,
//         settings: { slidesToShow: 1 }
//       }
//     ]
//   };

//   return (
//     <Box sx={{ py: 8, background: "#f8f9fb" }}>
//       <Container>

//         {/* Heading */}
//         <Typography
//           variant="h4"
//           align="center"
//           fontWeight="bold"
//           mb={5}
//         >
//           Why Interns Say About Us
//         </Typography>

//         <Slider {...settings}>
//           {testimonials.map((item, index) => (
//             <Box key={index} px={2}>
//               <Card
//                 sx={{
//                   p: 2,
//                   borderRadius: 3,
//                   height: "100%",
//                   boxShadow: "0 6px 18px rgba(0,0,0,0.08)"
//                 }}
//               >
//                 <CardContent>

//                   {/* Avatar + Name */}
//                   <Box
//                     display="flex"
//                     alignItems="center"
//                     mb={2}
//                   >
//                     <Avatar
//                       src={item.image}
//                       sx={{
//                         width: 50,
//                         height: 50,
//                         mr: 2
//                       }}
//                     />

//                     <Box>
//                       <Typography fontWeight="bold">
//                         {item.name}
//                       </Typography>

//                       <Typography
//                         variant="body2"
//                         color="description.secondary"
//                       >
//                         {item.designation}
//                       </Typography>
//                     </Box>
//                   </Box>

//                   {/* Description */}
//                   <Typography
//                     variant="body2"
//                     color="description.secondary"
//                   >
//                     {item.description}
//                   </Typography>

//                 </CardContent>
//               </Card>
//             </Box>
//           ))}
//         </Slider>

//       </Container>
//     </Box>
//   );
// };

// export default TestimonialSection;




import React, { useEffect, useRef, useState } from "react";
import girlIcon from "../../assets/images/girlicon.png";
import boyIcon from "../../assets/images/girlicon.png";


const testimonials = [
  {
    name: "Riya Sharma",
    designation: "Java Intern",
    description:
      "This internship gave me real exposure to production-level coding. I worked on backend APIs and understood how enterprise applications are structured.",
    image: "https://randomuser.me/api/portraits/women/65.jpg"
  },
  {
    name: "Rahul Verma",
    designation: "React Intern",
    description:
      "Working on real React projects helped me understand component architecture and state management used in production applications.",
    image: "https://randomuser.me/api/portraits/men/54.jpg"
  },
  {
    name: "Priya Patel",
    designation: "Python Intern",
    description:
      "The internship helped me build automation scripts and understand how Python is used in real industry projects.",
    image: "https://randomuser.me/api/portraits/women/72.jpg"
  },
  {
    name: "Aman Singh",
    designation: "Full Stack Intern",
    description:
      "I worked on frontend and backend modules and learned how APIs connect with user interfaces.",
    image: "https://randomuser.me/api/portraits/men/83.jpg"
  },
  {
    name: "Aditya Kumar",
    designation: "Frontend Intern",
    description:
      "During the internship I built React projects and created a strong portfolio that helped me confidently present my skills.",
    image: "https://randomuser.me/api/portraits/men/71.jpg"
  },
  {
    name: "Anjali Singh",
    designation: "Data Analytics Intern",
    description:
      "Working with real datasets using Python and Pandas helped me understand how companies analyze business data.",
    image: "https://randomuser.me/api/portraits/women/63.jpg"
  },
  {
    name: "Rohit Sharma",
    designation: "Backend Intern",
    description:
      "I built REST APIs and understood authentication and database connections used in backend systems.",
    image: "https://randomuser.me/api/portraits/men/45.jpg"
  },
  {
    name: "Neha Kapoor",
    designation: "UI/UX Intern",
    description:
      "Working on real UI tasks improved my design thinking and helped me build responsive interfaces.",
    image: "https://randomuser.me/api/portraits/women/55.jpg"
  },
  {
    name: "Karan Malhotra",
    designation: "Node.js Intern",
    description:
      "I developed backend APIs using Node.js and connected them with MongoDB databases.",
    image: "https://randomuser.me/api/portraits/men/66.jpg"
  },
  {
    name: "Sneha Gupta",
    designation: "Data Science Intern",
    description:
      "Working with datasets and visualization tools helped me understand practical data analysis.",
    image: "https://randomuser.me/api/portraits/women/41.jpg"
  },
  {
    name: "Arjun Mehta",
    designation: "Backend Intern",
    description:
      "Understanding how server logic and databases interact helped me grow as a backend developer.",
    image: "https://randomuser.me/api/portraits/men/61.jpg"
  },
  {
    name: "Pooja Agarwal",
    designation: "QA Testing Intern",
    description:
      "I learned how to test applications, identify bugs, and document issues in a structured testing process.",
    image: "https://randomuser.me/api/portraits/women/60.jpg"
  },
  {
    name: "Vikram Chauhan",
    designation: "DevOps Intern",
    description:
      "The internship introduced me to deployment pipelines and CI/CD workflows used in production environments.",
    image: "https://randomuser.me/api/portraits/men/52.jpg"
  },
  {
    name: "Ritika Sharma",
    designation: "Python Intern",
    description:
      "Writing automation scripts and working on backend tasks improved my Python development skills.",
    image: "https://randomuser.me/api/portraits/women/48.jpg"
  },
  {
    name: "Deepak Yadav",
    designation: "Full Stack Intern",
    description:
      "Connecting APIs with frontend components helped me understand complete application architecture.",
    image: "https://randomuser.me/api/portraits/men/73.jpg"
  },
  {
    name: "Nisha Verma",
    designation: "React Intern",
    description:
      "Learning React hooks and building real UI features improved my confidence as a frontend developer.",
    image: "https://randomuser.me/api/portraits/women/39.jpg"
  },
  {
    name: "Saurabh Mishra",
    designation: "Software Developer Intern",
    description:
      "Working with the development team helped me understand coding standards and collaborative workflows.",
    image: "https://randomuser.me/api/portraits/men/64.jpg"
  },
  {
    name: "Megha Jain",
    designation: "Web Development Intern",
    description:
      "Building responsive web pages and understanding modern tools made this internship very valuable.",
    image: "https://randomuser.me/api/portraits/women/70.jpg"
  },
  {
    name: "Harsh Patel",
    designation: "Machine Learning Intern",
    description:
      "I worked on small prediction models and explored real datasets for machine learning experiments.",
    image: "https://randomuser.me/api/portraits/men/68.jpg"
  }
];

const WallOfLove = () => {
  const trackRef = useRef(null);
  const [index, setIndex] = useState(0);

  const items = [...testimonials, ...testimonials]; // infinite

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => prev + 1);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    const card = track.children[0];
    const gap = 24;
    const step = card.offsetWidth + gap;

    track.style.transition = "transform 0.6s ease";
    track.style.transform = `translateX(-${index * step}px)`;

    if (index === testimonials.length) {
      setTimeout(() => {
        track.style.transition = "none";
        track.style.transform = "translateX(0)";
        setIndex(0);
      }, 600);
    }
  }, [index]);

  return (
    <>
      <style>{`
        .wol-wrap {
          max-width: 1200px;
          margin: auto;
          padding: 60px 20px;
          font-family: Inter, sans-serif;
          description-align: center;
        }

        .wol-title {
          font-size: 2.2rem;
          font-weight: 800; 
          text-align: center;
          color: #0f172a;
        }

        .wol-subtitle {
          margin-top: 10px;
          color: #6b7280;
        }

        .wol-slider {
          overflow: hidden;
          margin-top: 50px;
        }

        .wol-track {
          display: flex;
          gap: 24px;
        }

        .wol-card {
          flex: 0 0 calc(25% - 18px);
          
          border-radius: 10px;
          border: 1px solid #1a8984;
           background: linear-gradient(135deg, #19365b, #15807c);
           color:white;
          padding: 28px;
          description-align: left;
         
        }

        .wol-user {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .wol-user img {
          width: 50px;
          height: 50px;
          border-radius: 50%;
        }

        .wol-user h4 {
          margin: 0;
          font-size: 1rem;
          font-weight: 700;
        }

        .wol-user span {
          font-size: 0.85rem;
          color: white;
        }

        .wol-description {
          margin: 18px 0;
          font-size: 0.95rem;
          color: white;
          line-height: 1.6;
        }

        .wol-stars {
          color: #f97316;
          font-size: 1.1rem;
        }

        /* TABLET */
        @media (max-width: 1024px) {
          .wol-card {
            flex: 0 0 calc(50% - 12px);
          }
            .wol-wrap {
          width: 80vw;
          margin: auto;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .wol-card {
            flex: 0 0 100%;
            width: 80vw;
          }
            .wol-wrap {
          width: 80vw;
          margin: auto;
        
        }
        }
      `}</style>

      <section className="wol-wrap">
        <h2 className="wol-title">Why Interns <span style={{color:"#1a8984"}}>Say About Us</span> </h2>
        

        <div className="wol-slider">
          <div className="wol-track" ref={trackRef}>
            {items.map((item, i) => (
              <div className="wol-card" key={i}>
                <div className="wol-user">
                  {/* <img src={item.image} alt={item.name} /> */}
                  <div>
                    <h4>{item.name}</h4>
                    <span>{item.designation}</span>
                  </div>
                </div>
                <p className="wol-description">{item.description}</p>
                <div className="wol-stars">★★★★★</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default WallOfLove;